import MoneyInput from 'common/components/moneyInput/MoneyInput';
import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { useContext } from 'react';
import { LinesDataProvider } from '../../../../LinesDataProvider';
import ExpressionSystem from 'common/components/expressionButton/ExpressionSystem';
import { getExpressionParameters } from '../../../../utils';
import { BudgetLineDto } from 'api/budgets/models/BudgetDto';

interface Props {
    parameter: BudgetLineParameterDto;
    line: BudgetLineDto;
    disabled: boolean;
    onChange: (parameter: Partial<BudgetLineParameterDto>, calculateTotals: boolean) => void;
}

function ParameterPrice({ parameter, line, disabled, onChange }: Props): JSX.Element | null {
    const { units } = useContext(LinesDataProvider);
    const unitsOptions = units.map(u => ({ symbol: u.symbol, label: u.name, value: u.id }));

    const handleChangeUnit = (unitId: string | null | undefined) => {
        onChange({
            price: {
                ...(parameter.price ?? {}),
                unitId: unitId ?? null
            }
        }, false);
    };

    return (
        <MoneyInput
            value={parameter.price?.price ?? null}
            onBlur={(v) => {
                const tolerance = 0.000001;
                const currentValue = parameter.price?.price ?? 0;
                const newValue = v ?? 0;
                const isDifferent = Math.abs(currentValue - newValue) > tolerance;
                onChange({
                    price: {
                        ...(parameter.price ?? {}),
                        price: newValue,
                        priceExpression: isDifferent ? null : parameter.price?.priceExpression
                    }
                }, false);
            }}
            disabled={disabled}
            unit={parameter.price?.unitId ?? null}
            unitsOptions={unitsOptions}
            onChangeUnit={handleChangeUnit}
            popperFixed
            expressionButton={{
                title: ExpressionSystem.formatParameterName([parameter.parameterName ?? '']),
                value: parameter.price?.priceExpression ?? '',
                loadParameters: () => getExpressionParameters(line.key),
                onChange: (expr, value) => onChange({ price: { ...(parameter.price ?? {}), price: value ?? 0, priceExpression: expr } }, false)
            }}
        />
    );
}

export default ParameterPrice;
